import React from "react";
import testPasswordForce from "core/Utils/";

export default function PasswordStrength({ password = "" }) {
  function returnProgress() {
    let result = testPasswordForce(password);
    switch (result) {
      case "weak":
        return 10;
      case "medium":
        return 50;
      case "strong":
        return 75;
      case "stronger":
        return 100;
      default:
        return "weak";
    }
  }

  function returnStatus() {
    let result = testPasswordForce(password);
    switch (result) {
      case "weak":
        return "Fraca";
      case "medium":
        return "Média";
      case "strong":
        return "Forte";
      case "stronger":
        return "Muito Forte";
      default:
        return "weak";
    }
  }

  function returnProgressColor() {
    let result = testPasswordForce(password);
    switch (result) {
      case "weak":
        return "";
      case "medium":
        return "medium";
      case "strong":
        return " valid";
      case "stronger":
        return " valid";
      default:
        return "weak";
    }
  }

  return (
    <>
      <div className="mdn-ProgressBar mdn-ProgressBar--default">
        <div className="mdn-ProgressBar-percent" style={{ width: "100%" }}>
          <p
            className="mdn-ProgressBar-percentText mdn-Heading"
            style={{ float: "right", right: "0px" }}
          >
            {returnStatus()}
          </p>
        </div>
        <progress
          className={"mdn-ProgressBar-fill " + returnProgressColor()}
          value={parseInt(returnProgress())}
          max="100"
        ></progress>
      </div>
    </>
  );
}
